<template>
    <div class="lanceFooter reveal">
        <div class="footerContainer">

            <div class="blue-circle">
                <img src="img/mis_logo.svg" loading="lazy" alt="" >
                <div class="makeitsimple">make it simple</div>
            </div>

            <div class="SocialWrapper">
                <a style="--index:0" href="http://www.mis-implants.com" target="_blank" >
                     <img src="img/social/soc_mis.svg">
                </a>
                <a style="--index:1" href="http://www.facebook.com/MisImplantsTechnologiesLtdGlobal" target="_blank" >
                    <img src="img/social/soc_fb.svg">
                </a>
                <a style="--index:2" href="http://www.instagram.com/mis_implants_ltd_global/" target="_blank"  >
                    <img src="img/social/soc_ig.svg">
                </a>
                <a style="--index:3" href="http://www.linkedin.com/company/mis-implants-technologies-ltd-/mycompany/verification/" target="_blank"  >
                    <img src="img/social/soc_in.svg">
                </a>
                <a style="--index:4" href="http://www.youtube.com/c/MISImplantsTechnologiesLtd" target="_blank">
                    <img src="img/social/soc_youtube.svg">
                </a>
                <a style="--index:5" href="http://vimeo.com/misimplants" target="_blank"  >
                    <img src="img/social/soc_vimeo.svg">
                </a>
            </div>            

        </div>
    </div>
</template>

<style>    

    .lanceFooter
    {
        width: 100vw;
        height: 100%;
        background-color: #fff;
        z-index: 100;
        display: grid;
        align-items: center;
    }
    .lanceFooter .footerContainer
    {
      width: 100vw;
      text-align: center;color:#000;
    }

    .blue-circle {
        margin: auto;
        width: 450px;
        height: 450px;
        display: flex;
        margin-top: 0px;
        padding-left: 0px;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        border-radius: 1000px;
        background-color: #0076c0;
        opacity: 0;
        transition: all ease 0.5s;
        transition-delay: 0.6s;
    }
    .lanceFooter.active .blue-circle
    {
        opacity: 1;
    }

    .makeitsimple {
        margin-top: 5px;
        margin-bottom: 0px;
        color: #fff;
        font-size: 28px;
        font-weight: 300;
        letter-spacing: 1.5px;
        text-transform: uppercase;
    }    
    .SocialWrapper {
        display: block;
        margin-top: 30px;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .SocialWrapper a {
        padding: 4px 4px;        
        opacity: 1;
        filter: grayscale(0%);
    }
    .SocialWrapper a img{
        transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
        transition-property: all;
        transition-duration: 1s;
        transition-delay: calc(var(--index)*0.2s);
        opacity: 0;
        transform: translateY(20px);
    }
    .lanceFooter.active .SocialWrapper a img{
        opacity: 1;
        transform: translateY(0px);
    }

    @media (hover: hover) {
        .SocialWrapper a {
            cursor: pointer;
            opacity: 1;
        }
        .SocialWrapper a:hover {
            filter: grayscale(100%);
        }

    }

    @media (max-width: 850px) { 
        .lanceFooter
        {
            height: auto;
            padding: 100px 0px 100px 0px;        
        }
        .blue-circle {
            width: 250px;
            height: 250px;
            max-height: 300px;
            max-width: 300px;            
        }
        .blue-circle img{
            max-width: 50%;
        }
        .makeitsimple {
            font-size: 18px;
        }    
        .SocialWrapper
        {
            padding-top: 20px;
        }
        .SocialWrapper a img{
            width: 45px;height: 45px;
        }



    }  



</style>
<script>
import { mapActions, mapState } from "vuex";
import splitter from "@/views/com/splitter.vue";

export default {
    components:{splitter},
    data()
    {
        return{
            name:'footer'
        }
    },
    computed: {
        ...mapState(["siteData","siteDataReady"]),
        sectionData()
        {
            return [];//this.siteData.SECTIONS[1];
        }
    },
    methods:
    {

    }
};
</script>

